import { render, staticRenderFns } from "./SuccessIcon.vue?vue&type=template&id=6463ae08&"
import script from "./SuccessIcon.vue?vue&type=script&lang=js&"
export * from "./SuccessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports